// Horizontal smooth-scroll helper. Centers `target` inside `container`
// over `durationMs` using ease-out-cubic. Pass `durationMs = 0` to jump.
export function smoothScrollIntoViewHorizontally(
  container: HTMLElement,
  target: HTMLElement,
  durationMs: number,
): void {
  const containerRect = container.getBoundingClientRect()
  const targetRect = target.getBoundingClientRect()
  const offsetWithinContainer = targetRect.left - containerRect.left + container.scrollLeft
  const desiredScrollLeft = offsetWithinContainer - container.clientWidth / 2 + target.clientWidth / 2
  const maxScrollLeft = container.scrollWidth - container.clientWidth
  const endScrollLeft = Math.max(0, Math.min(desiredScrollLeft, maxScrollLeft))

  if (durationMs <= 0) {
    container.scrollLeft = endScrollLeft
    return
  }

  const startScrollLeft = container.scrollLeft
  const distance = endScrollLeft - startScrollLeft
  if (distance === 0) return

  const startTime = performance.now()
  const easeOutCubic = (t: number) => 1 - Math.pow(1 - t, 3)

  const step = (now: number) => {
    const elapsed = now - startTime
    const progress = Math.min(1, elapsed / durationMs)
    container.scrollLeft = startScrollLeft + distance * easeOutCubic(progress)
    if (progress < 1) requestAnimationFrame(step)
  }

  requestAnimationFrame(step)
}
